// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentGridDetail_wrapper__+JF3K","inputGroup":"CurrentGridDetail_inputGroup__HVGJE","blank":"CurrentGridDetail_blank__2-jRE"};